import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';


class ViewCapability extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Capability = null;

        if (this.props.Capability){
            this.data.Capability = this.props.Capability; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }

        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Capability){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/capability/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'type') &&
                            <PD.Tr>                                
                                <PD.Th>Type</PD.Th><PD.Td>{json.type}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'precondition') &&
                            <PD.Tr>
                                <PD.Th>Pre-Condition</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.precondition}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'postcondition') &&
                            <PD.Tr>
                                <PD.Th>Post-Condition</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.postcondition}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'System') &&
                            <PD.Tr>                                
                                <PD.Th>System</PD.Th>
                                <PD.Td>
                                    <PD.PdNavLink to={"/system/" + json.System._id}>{json.System.name}</PD.PdNavLink>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Dependencies') && json.Dependencies.length > 0 &&
                            <PD.Tr>
                                <PD.Th>Dependencies</PD.Th>
                                <PD.Td>
                                    {json.Dependencies.map((dep, index) => {
                                        return (
                                            <div key={index} style={{marginBottom: '8px'}}>
                                                <strong>{dep.type}</strong> <PD.PdNavLink to={`/capability/${dep.idCapability}`}>{dep.Capability?.name ?? dep.idCapability}</PD.PdNavLink>
                                                {dep.Capability?.description && (
                                                    <div style={{marginLeft: '20px', marginTop: '4px'}}>
                                                        <PD.MdPresent>{dep.Capability.description}</PD.MdPresent>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'DependencyOf') && json.DependencyOf.length > 0 &&
                            <PD.Tr>
                                <PD.Th>Dependency of</PD.Th>
                                <PD.Td>
                                    {json.DependencyOf.map((depof, indexC) => {
                                        return depof.Dependencies.map((dep, indexD) => {
                                            if (dep.idCapability === json._id){
                                                return (
                                                    <div key={`${indexC}_${indexD}`} style={{marginBottom: '8px'}}>
                                                        <PD.PdNavLink to={`/capability/${depof._id}`}>{depof.name ?? depof._id}</PD.PdNavLink> <strong>{dep.type}</strong>
                                                        {depof.description && (
                                                            <div style={{marginLeft: '20px', marginTop: '4px'}}>
                                                                <PD.MdPresent>{depof.description}</PD.MdPresent>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            }                                            else{
                                                return null;
                                            }
                                    });})}
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'Solution') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Solution</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/solution/" + json.Solution._id} > {json.Solution.name}</PD.PdNavLink>
                                    </PD.Td>
                                </PD.Tr>

                                {json.Solution.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.Solution.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>

                        }


                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Capability)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewCapability;